import * as types from "../types/usuario";

const INITIAL_STATE = {
  loading: false,
  usuario: {},
  plano: {},
  consumo: {},
  planoClienteLoading: false,
  clienteLoad: {},
  assinaturaLoading: false,
  assinaturaLoad: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.USUARIO_LOADING:
      return { ...state, loading: action.payload };
    case types.USUARIO_SET:
      return { ...state, usuario: action.payload };

    case types.CHANGE_CLIENTE_PLANOS:
      return { ...state, plano: action.payload };

    case types.CHANGE_PLANO_CLIENTE_LOADING:
      return { ...state, planoClienteLoading: action.payload };

    case types.CHANGE_CLIENTE_DADOS_LOAD:
      return { ...state, clienteLoad: action.payload };

    case types.CHANGE_DADOS_ASSINATURA_LOADING:
      return { ...state, assinaturaLoading: action.payload };

    case types.CHANGE_DADOS_ASSINATURA_LOAD:
      return { ...state, assinaturaLoad: action.payload };

    default:
      return state;
  }
};
